<template>
  <v-expansion-panel style="border-radius: 6px">
    <v-expansion-panel-header
      style="font-weight: 600; color: #746b6b; font-size: 12x"
    >
      {{ $t("events.comission") }}
    </v-expansion-panel-header>
    <v-expansion-panel-content class="py-6">
      <v-row>
        <v-col cols="12">
          <BaseSelect
            tabindex="1"
            :label="$t('events.event-config.comission-imply-web')"
            :placeholder="$t('events.event-config.select-fee-type')"
            no-data-text=""
            item-text="value"
            hide-details
            item-value="key"
            :clearable="false"
            :items="$produtos_gerenciar.cadastro.tipoComissaoWeb"
            v-model="
              $produtos_gerenciar.cadastro.dados_cadastrais.tipoComissaoWeb
            "
          />
        </v-col>
        <v-col cols="12">
          <BaseSelect
            tabindex="1"
            :label="$t('events.event-config.comission-imply-pos')"
            :placeholder="$t('events.event-config.select-web-comission-fee')"
            no-data-text=""
            hide-details
            item-text="value"
            item-value="key"
            :clearable="false"
            :items="$produtos_gerenciar.tipoTaxaWeb"
            v-model="$produtos_gerenciar.cadastro.dados_cadastrais.tipoTaxaWeb"
          />
        </v-col>
        <v-col cols="12" v-if="taxTypeWebIsPercent">
          <BaseTextField
            tabindex="5"
            :label="$t('events.event-config.fee') + ' (%)'"
            placeholder="0"
            type="number"
            prefix="%"
            v-model="
              $produtos_gerenciar.cadastro.dados_cadastrais.percentual_taxa_web
            "
          />
        </v-col>
        <v-col cols="12" v-if="taxTypeWebIsValues">
          <BaseMoneyField
            :label="$t('events.event-config.fee') + ' (R$)'"
            placeholder="0,00"
            :hideDetails="false"
            v-model="
              $produtos_gerenciar.cadastro.dados_cadastrais.valor_taxa_web
            "
            :options="options5"
          ></BaseMoneyField>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <BaseSelect
            tabindex="1"
            :label="$t('events.event-config.comission-imply-pos')"
            :placeholder="$t('events.event-config.select-fee-type')"
            no-data-text=""
            item-text="value"
            hide-details
            item-value="key"
            :clearable="false"
            :items="$produtos_gerenciar.cadastro.tipoComissaoPos"
            v-model="
              $produtos_gerenciar.cadastro.dados_cadastrais.tipoComissaoPos
            "
          />
        </v-col>
        <v-col cols="12">
          <BaseSelect
            tabindex="1"
            :label="$t('events.event-config.comission-pos-type')"
            :placeholder="$t('events.event-config.select-pos-fee-type')"
            no-data-text=""
            item-text="value"
            item-value="key"
            hide-details
            :clearable="false"
            :items="$produtos_gerenciar.tipoTaxaPos"
            v-model="$produtos_gerenciar.cadastro.dados_cadastrais.tipoTaxaPos"
          />
        </v-col>
        <v-col cols="12" v-if="taxTypePosIsPercent">
          <BaseTextField
            tabindex="5"
            :label="$t('events.event-config.fee') + ' (%)'"
            placeholder="0"
            type="number"
            prefix="%"
            hide-details
            v-model="
              $produtos_gerenciar.cadastro.dados_cadastrais.percentual_taxa_pos
            "
          />
        </v-col>
        <v-col cols="12" v-if="taxTypePosIsValues">
          <BaseMoneyField
            :label="$t('events.event-config.fee') + ' (R$)'"
            placeholder="0,00"
            hide-details
            v-model="
              $produtos_gerenciar.cadastro.dados_cadastrais.valor_taxa_pos
            "
            :options="options5"
          ></BaseMoneyField>
        </v-col>
        <v-col cols="12" class="mb-n4" v-if="isAdmin">
          <v-checkbox
            v-model="
              $produtos_gerenciar.cadastro.dados_cadastrais.onProcessamento
            "
            :label="$t('events.event-config.enable-processing-fee')"
          >
          </v-checkbox>
        </v-col>
        <v-col cols="12" v-if="labelProccessTaxDisabled && isAdmin">
          <BaseMoneyField
            :label="$t('events.event-config.processing-fee')"
            placeholder="0,00"
            v-model="
              $produtos_gerenciar.cadastro.dados_cadastrais.taxa_processamento
            "
            :options="options5"
          ></BaseMoneyField>
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
import BaseSelect from "@/components/forms/BaseSelect.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseMoneyField from "@/components/forms/BaseMoneyField.vue";
export default {
  name: "Comission",
  components: {
    BaseMoneyField,
    BaseSelect,
    BaseTextField,
  },
  data() {
    return {
      options5: {
        locale: "pt-BR",
        prefix: "R$",
        suffix: "",
        length: 9,
        precision: 2,
      },
    };
  },
  computed: {
    labelCommissionDisabled() {
      if (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.comissao !==
        "personalizada"
      )
        return true;
      return false;
    },
    labelCommissionStyle() {
      if (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.comissao !==
        "personalizada"
      )
        return "label-disabled";
      return "";
    },
    taxIsTypeCommission() {
      if (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipoComissaoWeb ===
        "COMISSAO"
      )
        return true;
      return false;
    },
    taxIsTypeConvenience() {
      if (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipoComissaoWeb ===
        "CONVENIENCIA"
      )
        return true;
      return false;
    },
    taxTypeWebIsValues() {
      if (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipoTaxaWeb ===
        "VALOR"
      )
        return true;
      return false;
    },
    taxTypeWebIsPercent() {
      if (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipoTaxaWeb ===
        "PERCENTUAL"
      )
        return true;
      return false;
    },
    taxTypePosIsValues() {
      if (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipoTaxaPos ===
        "VALOR"
      )
        return true;
      return false;
    },
    taxTypePosIsPercent() {
      if (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipoTaxaPos ===
        "PERCENTUAL"
      )
        return true;
      return false;
    },
    processamentoCheck() {
      if (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.taxa_processamento >
        0
      )
        return true;
      return false;
    },
    labelProccessTaxDisabled() {
      if (this.$produtos_gerenciar.cadastro.dados_cadastrais.onProcessamento)
        return true;
      return false;
    },
    isAdmin() {
      if (this.$axios.getLocal("oe_user_info").data.user_type === "admin")
        return true;
      return false;
    },
  },
  watch: {
    "$produtos_gerenciar.cadastro.dados_cadastrais.onProcessamento"(value) {
      if (!value) {
        this.$produtos_gerenciar.cadastro.dados_cadastrais.taxa_processamento =
          "0";
      }
    },
    "$produtos_gerenciar.cadastro.dados_cadastrais.taxa_processamento"(value) {
      if (value > 0) {
        this.$produtos_gerenciar.cadastro.dados_cadastrais.onProcessamento = true;
      }
    },
    "$produtos_gerenciar.cadastro.dados_cadastrais.tipoTaxaWeb"(e) {
      if (e === "VALOR") {
        this.$produtos_gerenciar.cadastro.dados_cadastrais.valor_taxa_web = "0";
        this.$produtos_gerenciar.cadastro.dados_cadastrais.percentual_taxa_web =
          "0";
      } else {
        this.$produtos_gerenciar.cadastro.dados_cadastrais.percentual_taxa_web =
          "10";
        this.valor_taxa_web = "0";
      }
    },
  },
  mounted() {
    this.$produtos_gerenciar.cadastro.dados_cadastrais.onProcessamento =
      this.processamentoCheck;
  },
};
</script>
<style scoped>
.lojas-gerenciar-comissao-antecipacao-subtitle {
  width: 487px;
  font-size: 1rem;
  align-self: flex-start;
  margin-top: 1.25rem;
}

.lojas-gerenciar-comissao-antecipacao {
  width: 100%;
  height: 100%;
  align-items: center;
  flex-direction: column;
}
</style>
